import { RootContainer } from '../../../../core/root_container';
import { CategoryMJsEnv } from '../../models/category_m_js_env';
import {
  RrBodyNormalLower,
  RrBodyNormalUpper,
  RrBodyLeftSide,
} from './rr_body';
import { applyCarouselStyle } from '../../../../core/views/common/carousel_util';

export class CategoryMForMakerBrandContainer extends RootContainer<CategoryMJsEnv> {
  constructor(model: CategoryMJsEnv) {
    super();

    //メーカー・ブランド
    this.mount(RrBodyNormalLower, model.rrAreaProfileNormalLower.placementName);
    this.mount(RrBodyNormalUpper, model.rrAreaProfileNormalUpper.placementName);
    this.mount(RrBodyLeftSide, model.rrAreaProfileLeftSide.placementName);
    // 初回描画
    this.update(model);

    const carouselIdList = [
      model.rrAreaProfileNormalLower.placementName,
      model.rrAreaProfileNormalUpper.placementName,
      model.rrAreaProfileLeftSide.placementName
    ].map(placementName => placementName + "-carousel")

    applyCarouselStyle(carouselIdList)
  }
}
